import React from 'react';
import Icon from '../../../components/AppIcon';

const PrinterStatusDashboard = ({ status, loading, onRefresh }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {[...Array(4)]?.map((_, i) => (
          <div key={i} className="bg-white rounded-lg shadow-sm p-6 animate-pulse">
            <div className="h-4 bg-gray-200 rounded w-3/4 mb-4"></div>
            <div className="h-8 bg-gray-200 rounded w-1/2"></div>
          </div>
        ))}
      </div>
    );
  }

  if (!status) return null;

  const statusColor = status?.connected && status?.status === 'ready' ? 'green' : 'red';
  const ribbonColor = status?.ribbonLevel > 50 ? 'green' : status?.ribbonLevel > 20 ? 'yellow' : 'red';
  const cardStockColor = status?.cardStock > 50 ? 'green' : status?.cardStock > 20 ? 'yellow' : 'red';

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
      {/* Connection Status */}
      <div className="bg-white rounded-lg shadow-sm p-6 border-l-4 border-blue-600">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-sm font-medium text-gray-600">Printer Status</h3>
          <Icon 
            name={status?.connected ? 'CheckCircle' : 'XCircle'} 
            className={`w-5 h-5 text-${statusColor}-600`} 
          />
        </div>
        <p className="text-2xl font-bold text-gray-900">{status?.model}</p>
        <p className={`text-sm mt-2 font-medium text-${statusColor}-600`}>
          {status?.connected ? 'Connected' : 'Disconnected'}
        </p>
      </div>
      {/* Ribbon Level */}
      <div className="bg-white rounded-lg shadow-sm p-6 border-l-4 border-purple-600">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-sm font-medium text-gray-600">Ribbon Level</h3>
          <Icon name="Droplet" className={`w-5 h-5 text-${ribbonColor}-600`} />
        </div>
        <p className="text-2xl font-bold text-gray-900">{status?.ribbonLevel}%</p>
        <div className="mt-3 w-full bg-gray-200 rounded-full h-2">
          <div 
            className={`bg-${ribbonColor}-600 h-2 rounded-full transition-all`}
            style={{ width: `${status?.ribbonLevel}%` }}
          ></div>
        </div>
      </div>
      {/* Card Stock */}
      <div className="bg-white rounded-lg shadow-sm p-6 border-l-4 border-green-600">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-sm font-medium text-gray-600">Card Stock</h3>
          <Icon name={"CreditCard"} className={`w-5 h-5 text-${cardStockColor}-600`} />
        </div>
        <p className="text-2xl font-bold text-gray-900">{status?.cardStock}</p>
        <p className="text-sm text-gray-600 mt-2">cards remaining</p>
      </div>
      {/* Total Printed */}
      <div className="bg-white rounded-lg shadow-sm p-6 border-l-4 border-orange-600">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-sm font-medium text-gray-600">Total Printed</h3>
          <Icon name="TrendingUp" className="w-5 h-5 text-orange-600" />
        </div>
        <p className="text-2xl font-bold text-gray-900">{status?.totalPrinted?.toLocaleString()}</p>
        <p className="text-sm text-gray-600 mt-2">lifetime cards</p>
      </div>
      {/* Maintenance Alert */}
      {status?.nextMaintenance && (
        <div className="md:col-span-4 bg-yellow-50 border border-yellow-200 rounded-lg p-4 flex items-start gap-3">
          <Icon name="AlertTriangle" className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="font-semibold text-yellow-900">Maintenance Reminder</h3>
            <p className="text-yellow-700 text-sm">
              Next scheduled maintenance: {new Date(status?.nextMaintenance)?.toLocaleDateString()}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default PrinterStatusDashboard;
